export class AptRecaptchaComponentCtrl {
  onUpdateResponseToken;

  captchaSiteKey: string; // either testingSiteKey or prodSiteKey depending on host

  gRecaptchaApi;

  testingSiteKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // https://developers.google.com/recaptcha/docs/faq#localhost_support

  // public site key could be implemented through binding or in a value service but we will only ever need one
  prodSiteKey = '6LcqNEwUAAAAAIZ4l8tPCpUru2xrH97JR3cLEFt1';

  // recaptcha.render requires an element ID or an element reference
  // I don't favor either so we will dynamically generate an Id
  recaptchaContainerId: string;

  // ID returned by recaptcha.render
  widgetId;

  constructor(private $window, private $location, private $scope) {
    'ngInject';
  }

  $onInit() {
    // register recaptcha callback
    this.$window.onRecaptchaApiReady = () => this.onRecaptchaApiReady();

    // chose siteKey depending on host
    this.captchaSiteKey =
      this.$location.host() === 'localhost'
        ? this.testingSiteKey
        : this.prodSiteKey;

    // generate unique id to use for recaptcha container
    this.recaptchaContainerId = `recaptchaContainerId${new Date().valueOf()}`;
  }

  onRecaptchaApiReady() {
    this.gRecaptchaApi = this.$window.grecaptcha as any || {};

    // Throw an error if the API is not available.
    // Unless Google changes the API, this should never happen.
    console.assert(this.gRecaptchaApi.render, 'grecaptcha not avialable');

    this.widgetId = this.gRecaptchaApi.render(this.recaptchaContainerId, {
      sitekey: this.captchaSiteKey,
      callback: (token) => this.onRecaptchaResponse(token),
      'expired-callback': () => this.onRecaptchaExpired()
    });
  }

  onRecaptchaExpired() {
    this.updateResponseToken();
  }

  onRecaptchaResponse(token) {
    this.updateResponseToken(token);
  }

  updateResponseToken(captchaToken = '') {
    let recaptchaResponse = {
      captchaToken,
      resetRecaptcha: () => this.resetRecaptcha()
    };

    this.onUpdateResponseToken(recaptchaResponse);

    // recaptcha callbacks happens outside of Angular's scope so
    // so we need to schedule a digest
    this.$scope.$applyAsync();
  }

  resetRecaptcha() {
    this.gRecaptchaApi.reset(this.widgetId);
    this.updateResponseToken();
  }
}

export const AptRecaptchaComponent = {
  bindings: {
    onUpdateResponseToken: '&'
  },
  controller: AptRecaptchaComponentCtrl,
  template: `
    <div data-test-selector="recaptchaContainer" id="{{$ctrl.recaptchaContainerId}}"></div>

    <script src="https://www.google.com/recaptcha/api.js?onload=onRecaptchaApiReady"></script>
  `
};
